import React, { FC } from 'react';

import { Stack, Typography } from '@mui/material';

interface SettingsStackProps {
  /**
   * The main header for the settings page
   */
  header?: string;
  /**
   * An optional subheader for the settings page
   */
  subheader?: string;
  /**
   * An optional action (e.g. button) for the settings page
   */
  headerAction?: React.ReactNode;
  /**
   * An optional max width override
   */
  maxWidth?: number | string;
  /**
   * An optional input to add illustration in header
   */
  decoration?: React.ReactNode;
  children?: React.ReactNode;
}

/**
 * Helper component for Settings pages to provide consistent spacing and styling
 * Should be used as a child of SettingsStack
 */
export const SettingsStack: FC<SettingsStackProps> = ({
  header,
  subheader,
  headerAction,
  children,
  maxWidth = '960px',
  decoration,
}) => {
  return (
    <Stack gap={3} sx={{ maxWidth, height: '100%' }}>
      {(decoration || header || subheader || headerAction) && (
        <Stack direction="row">
          <Stack sx={{ mt: 1 }} flex={1}>
            <Stack direction="row" alignItems="center" spacing={1}>
              {decoration}
              {header && (
                <Typography color="text.primary" variant="h4">
                  {header}
                </Typography>
              )}
            </Stack>
            {subheader && (
              <Typography pt={1} color="text.secondary">
                {subheader}
              </Typography>
            )}
          </Stack>
          {headerAction && <>{headerAction}</>}
        </Stack>
      )}

      {children}
    </Stack>
  );
};
